// CHO form config

export const choFields = [
    {
        name: 'name',
        label: 'Name',
        type: 'text',
        validation: [{ name: 'required' }]
    },
    {
        name: 'address_street_no',
        label: 'Address Street Number',
        type: 'text',
        validation: [{name: 'required'}]
    },
    {
        name: 'address_county',
        label: 'Address County',
        type: 'text',
        validation: {},
    },
    {
        name: 'address_city',
        label: 'Address City',
        type: 'text',
        validation: {},
    },
    {
        name: 'address_post_code',
        label: 'Address Post Code',
        type: 'text',
        validation: [{name: 'required'}]
    },
    {
        name: 'telephone',
        label: 'Telephone',
        type: 'text',
        validation: {},
    },
    {
        name: 'email',
        label: 'Email',
        type: 'text',
        validation: [{name: 'email'}, {name: 'required'}]
    },
    {
        name: 'sla',
        label: 'SLA',
        type: 'integer',
        defaultValue: 7,
        validation: {},
    }
];
